import { render, staticRenderFns } from "./RegulatoryUpdatePersonalRegister.vue?vue&type=template&id=363f49e7&scoped=true"
import script from "./RegulatoryUpdatePersonalRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegulatoryUpdatePersonalRegister.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RegulatoryUpdatePersonalRegister.vue?vue&type=style&index=0&id=363f49e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f49e7",
  null
  
)

export default component.exports